import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-list-programa',
  templateUrl: './list-programa.component.html',
  styleUrls: ['./list-programa.component.scss']
})
export class ListProgramaComponent implements OnInit {

  public arrayTriagem: [];
  query: string;

  constructor(
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  adicionarNovoPrograma(){
    this.router.navigate(['/cadastro-programa']);
  }

  alertas(){
    this.router.navigate(['/avisos']);
  }


  documentos(){
    this.router.navigate(['/documentos']);
  }



  buscar(){
    this.util.showLoading();
    //let url = API + "Triagem/Triagem";  
    let url = "fake-data/programa.json";  
    return this.ajax.get(url)
    .subscribe(response  => {
      this.arrayTriagem = response;

      this.util.closeLoading();      
    }, err => {
      debugger
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Buscar Triagem");
    });
  }

}
